import { Dispatch, GetState } from "../types/types";
import h from "../helpers";
import { request } from "../helpers/httpInterceptor";
import { notifyGreen, notifyBlue } from "./notifyActions";
import {
    Comments,
    DonationData,
    DonorHistory,
    IGetPromotionData,
    IGetDonationData,
    IGetLinkedDonationData,
    PromotionData,
    ISetServiceCenterZip,
    LinkedDonationData,
    BatchCategory,
    IGetBatchCategories,
} from "../types/stores/makeAWish";
import { goToUrl } from "./actionCreators";
import { IAppState } from "../types/stores/index";
import { ServiceCenterZip } from "../types/stores/makeAWish";
import { GET_BATCH_CATEGORIES, SET_SERVICE_CENTER_ZIP } from "../reducers/makeAWish";
import {
    Address,
    AddressType,
    IAddHeaderRecord,
    IUpdateHeaderRecord,
    ISetMailOnlySuppress,
    MemberCode,
    OriginCode,
    ServiceCenter,
    Donor,
    ISetDonorIsLoading,
    IGetDonor,
    ISetAdditionalMessage,
    SearchDonor,
    IResetDonor,
    IGetEditDonor,
    IGetEditDonorHistory,
    IUpdateComments,
    IGetAddressType,
    IGetMemberCode,
    IGetOriginCode,
    IGetServiceCenter,
    IGetAcknowledgmentFlag,
    IGetFormCode,
    IGetGiftSummary,
    IGetAddressSummary,
    IGetAuditRecordsCount,
    IGetAuditRecords,
    IUpdateAuditRecord,
    IGetAuditRecord,
    IGetUserBatches,
    IGetCurrentBatch,
    IAddAuditRecord,
    IGetBatchDonor,
    Batch,
    IGetAppealCode,
    IDeleteBatchRecord,
    IDeleteAuditRecord,
    IGetUnusedInfoCodes,
    IGetUsedInfoCodes,
    IGetUnusedCampaignCodes,
    IGetUsedCampaignCodes,
    IGetUnusedFinanceCodes,
    IGetUsedFinanceCodes,
    InfoCode,
    CampaignCode,
    FinanceCode,
    ISetCodesLoading,
    ISetPromotionsLoading,
    ISetDonationsLoading,
    IDeleteDonationRecord,
    IGetOtherAddresses,
    IGetDonorStore,
    ISetReportsLoading,
    ISetReports,
    ISetUserPermission,
    ISetAllUserPermission,
    UserPermission,
    IReport,
    ISetAllGiftsLoading,
    ISetAllGifts,
    IGift,
    IUpdatedAuditableBatch,
    TributeType,
    GiftType,
    IGetTributeType,
    IGetGiftType,
} from "../types/stores/makeAWish";
import {
    SET_DONOR_IS_LOADING,
    GET_DONOR,
    SET_SEARCH_MESSAGE,
    RESET_DONOR,
    GET_EDIT_DONOR,
    GET_EDIT_DONOR_HISTORY,
    UPDATE_COMMENTS,
    GET_ADDRESS_TYPE,
    GET_MEMBER_CODE,
    GET_ORIGIN_CODE,
    GET_SERVICE_CENTER,
    GET_ACKNOWLEDGMENT_FLAG,
    GET_FORM_CODE,
    GET_GIFT_SUMMARY,
    GET_ADDRESS_SUMMARY,
    GET_AUDIT_RECORDS_COUNT,
    GET_AUDIT_RECORDS,
    UPDATE_AUDIT_RECORD,
    GET_AUDIT_RECORD,
    GET_USER_BATCHES,
    GET_CURRENT_BATCH,
    ADD_AUDIT_RECORD,
    GET_BATCH_DONOR,
    GET_APPEAL_CODE,
    DELETE_BATCH_RECORD,
    DELETE_AUDIT_RECORD,
    GET_USED_INFO_CODES,
    GET_PROMOTION_DATA,
    GET_DONATION_DATA,
    GET_LINKED_DONATION_DATA,
    GET_UNUSED_INFO_CODES,
    GET_USED_CAMPAIGN_CODES,
    GET_UNUSED_CAMPAIGN_CODES,
    GET_USED_FINANCE_CODES,
    GET_UNUSED_FINANCE_CODES,
    SET_CODES_LOADING,
    SET_PROMOTIONS_LOADING,
    SET_DONATIONS_LOADING,
    GET_OTHER_ADDRESSES,
    SET_MAIL_ONLY_SUPPRESS,
    ADD_HEADER_RECORD,
    UPDATE_HEADER_RECORD,
    SET_REPORTS_LOADING,
    SET_REPORTS,
    SET_USER_PERMISSION,
    SET_ALL_USER_PERMISSIONS,
    SET_ALL_GIFTS_LOADING,
    SET_ALL_GIFTS,
    UPDATED_AUDITABLE_BATCH,
    GET_TRIBUTE_TYPE,
    GET_GIFT_TYPE,
    DELETE_DONATION_RECORD,
} from "../reducers/makeAWish";
import { CaseSensitive } from "../components/make-a-wish/MakeAWishSearch";

export const GetDonor = (data: Array<SearchDonor>): IGetDonor => ({
    type: GET_DONOR,
    donorsData: data,
});

export const setSearchMessage = (data: string): ISetAdditionalMessage => ({
    type: SET_SEARCH_MESSAGE,
    searchMessage: data,
});

export const resetSearch = (): IResetDonor => ({
    type: RESET_DONOR,
    donorsData: [],
    clientsData: [],
});

export const GetEditDonor = (data: Array<Donor>): IGetEditDonor => ({
    type: GET_EDIT_DONOR,
    editDonorsData: data,
});

export const UpdateComments = (data: Array<Comments>): IUpdateComments => ({
    type: UPDATE_COMMENTS,
    comments: data,
});

export const GetEditDonorHistory = (data: DonorHistory): IGetEditDonorHistory => ({
    type: GET_EDIT_DONOR_HISTORY,
    editDonorsHistoryData: data,
});

export const SetDonorIsLoading = (isLoading: boolean): ISetDonorIsLoading => ({
    type: SET_DONOR_IS_LOADING,
    isLoading,
});

export const GetAddressType = (data: Array<AddressType>): IGetAddressType => ({
    type: GET_ADDRESS_TYPE,
    addressType: data,
});

export const GetMemberCode = (data: Array<MemberCode>): IGetMemberCode => ({
    type: GET_MEMBER_CODE,
    memberCode: data,
});

export const GetOriginCode = (data: Array<OriginCode>): IGetOriginCode => ({
    type: GET_ORIGIN_CODE,
    originCode: data,
});

export const GetServiceCenter = (data: Array<ServiceCenter>): IGetServiceCenter => ({
    type: GET_SERVICE_CENTER,
    serviceCenter: data,
});

export const GetAcknowledgmentFlag = (data: Array<IGetDonorStore>): IGetAcknowledgmentFlag => ({
    type: GET_ACKNOWLEDGMENT_FLAG,
    acknowledgmentFlags: data,
});

export const GetFormCode = (data: Array<IGetDonorStore>): IGetFormCode => ({
    type: GET_FORM_CODE,
    formCodes: data,
});

export const GetAppealCode = (data: Array<IGetDonorStore>): IGetAppealCode => ({
    type: GET_APPEAL_CODE,
    appealCodes: data,
});

export const GetGiftSummary = (data: string): IGetGiftSummary => ({
    type: GET_GIFT_SUMMARY,
    giftSummary: data,
});

export const GetAddressSummary = (data: string): IGetAddressSummary => ({
    type: GET_ADDRESS_SUMMARY,
    addressSummary: data,
});

export const GetAuditRecordsCount = (data: Array<IGetDonorStore>): IGetAuditRecordsCount => ({
    type: GET_AUDIT_RECORDS_COUNT,
    auditRecordsCount: data,
});

export const GetAuditRecords = (data: Array<IGetDonorStore>): IGetAuditRecords => ({
    type: GET_AUDIT_RECORDS,
    auditRecords: data,
});

export const GetAuditRecord = (data: IGetDonorStore): IGetAuditRecord => ({
    type: GET_AUDIT_RECORD,
    auditRecord: data,
});

export const GetUserBatches = (data: Array<IGetDonorStore>): IGetUserBatches => ({
    type: GET_USER_BATCHES,
    batchesData: data,
});

export const GetCurrentBatch = (data: IGetDonorStore): IGetCurrentBatch => ({
    type: GET_CURRENT_BATCH,
    batchData: data,
});

export const AddAuditRecord = (data: Array<IGetDonorStore>): IAddAuditRecord => ({
    type: ADD_AUDIT_RECORD,
    addBatchData: data,
});

export const UpdateAuditRecord = (data: Array<IGetDonorStore>): IUpdateAuditRecord => ({
    type: UPDATE_AUDIT_RECORD,
    updateBatchData: data,
});

export const GetBatchDonor = (data: IGetDonorStore): IGetBatchDonor => ({
    type: GET_BATCH_DONOR,
    batchDonorData: data,
});

export const DeleteBatchRecord = (data: boolean): IDeleteBatchRecord => ({
    type: DELETE_BATCH_RECORD,
    deleteBatch: data,
});

export const DeleteAuditRecord = (data: boolean): IDeleteAuditRecord => ({
    type: DELETE_AUDIT_RECORD,
    deleteAudit: data,
});

export const DeleteDonationRecord = (data: boolean): IDeleteDonationRecord => ({
    type: DELETE_DONATION_RECORD,
    deleteDonation: data,
});

export const GetUnusedInfoCodes = (unusedInfoCodes: Array<InfoCode>): IGetUnusedInfoCodes => ({
    type: GET_UNUSED_INFO_CODES,
    unusedInfoCodes,
});

export const GetUsedInfoCodes = (usedInfoCodes: Array<InfoCode>): IGetUsedInfoCodes => ({
    type: GET_USED_INFO_CODES,
    usedInfoCodes,
});

export const GetPromotionData = (promotionData: PromotionData): IGetPromotionData => ({
    type: GET_PROMOTION_DATA,
    promotionData,
});

export const GetDonationData = (donationData: DonationData): IGetDonationData => ({
    type: GET_DONATION_DATA,
    donationData,
});

export const GetLinkedDonationData = (linkedDonationData: LinkedDonationData): IGetLinkedDonationData => ({
    type: GET_LINKED_DONATION_DATA,
    linkedDonationData,
});

export const GetUnusedCampaignCodes = (unusedCampaignCodes: Array<CampaignCode>): IGetUnusedCampaignCodes => ({
    type: GET_UNUSED_CAMPAIGN_CODES,
    unusedCampaignCodes,
});

export const GetUsedCampaignCodes = (usedCampaignCodes: Array<CampaignCode>): IGetUsedCampaignCodes => ({
    type: GET_USED_CAMPAIGN_CODES,
    usedCampaignCodes,
});

export const SetCodesLoading = (isCodesLoading: boolean): ISetCodesLoading => ({
    type: SET_CODES_LOADING,
    isCodesLoading,
});

export const SetPromotionsLoading = (isPromotionsLoading: boolean): ISetPromotionsLoading => ({
    type: SET_PROMOTIONS_LOADING,
    isPromotionsLoading,
});

export const SetDonationsLoading = (isDonationsLoading: boolean): ISetDonationsLoading => ({
    type: SET_DONATIONS_LOADING,
    isDonationsLoading,
});

export const SetMailOnlySuppress = (mailOnlySuppress: string): ISetMailOnlySuppress => ({
    type: SET_MAIL_ONLY_SUPPRESS,
    mailOnlySuppress,
});

export const GetUnusedFinanceCodes = (unusedFinanceCodes: Array<FinanceCode>): IGetUnusedFinanceCodes => ({
    type: GET_UNUSED_FINANCE_CODES,
    unusedFinanceCodes,
});

export const GetUsedFinanceCodes = (usedFinanceCodes: Array<FinanceCode>): IGetUsedFinanceCodes => ({
    type: GET_USED_FINANCE_CODES,
    usedFinanceCodes,
});

export const GetOtherAddresses = (otherAddresses: Array<Address>): IGetOtherAddresses => ({
    type: GET_OTHER_ADDRESSES,
    otherAddresses,
});

export const AddHeaderRecord = (data: Array<IGetDonorStore>): IAddHeaderRecord => ({
    type: ADD_HEADER_RECORD,
    newBatchNumber: data,
});

export const UpdateHeaderRecord = (): IUpdateHeaderRecord => ({
    type: UPDATE_HEADER_RECORD,
});

export const SetIsReportsLoading = (isReportsLoading: boolean): ISetReportsLoading => ({
    type: SET_REPORTS_LOADING,
    isReportsLoading,
});

export const SetReports = (reports: Array<IReport>): ISetReports => ({
    type: SET_REPORTS,
    reports,
});

export const SetUserPermission = (permission: UserPermission): ISetUserPermission => ({
    type: SET_USER_PERMISSION,
    permission,
});

export const SetAllUserPermissions = (userPermissions: Array<UserPermission>): ISetAllUserPermission => ({
    type: SET_ALL_USER_PERMISSIONS,
    userPermissions,
});

export const SetIsAllGiftsLoading = (isAllGiftsLoading: boolean): ISetAllGiftsLoading => ({
    type: SET_ALL_GIFTS_LOADING,
    isAllGiftsLoading,
});

export const SetAllGifts = (allGifts: Array<IGift>): ISetAllGifts => ({
    type: SET_ALL_GIFTS,
    allGifts,
});

export const UpdatedAuditableBatch = (): IUpdatedAuditableBatch => ({
    type: UPDATED_AUDITABLE_BATCH,
});

export const GetTributeType = (data: Array<TributeType>): IGetTributeType => ({
    type: GET_TRIBUTE_TYPE,
    tributeType: data,
});

export const GetGiftType = (data: Array<GiftType>): IGetGiftType => ({
    type: GET_GIFT_TYPE,
    giftType: data,
});

export const GetBatchCategories = (data: Array<BatchCategory>): IGetBatchCategories => ({
    type: GET_BATCH_CATEGORIES,
    batchCategories: data,
});

export const SetServiceCenterZip = (data?: ServiceCenterZip): ISetServiceCenterZip => ({
    type: SET_SERVICE_CENTER_ZIP,
    serviceCenterZip: data,
});

export const getDonorAsync =
    (data: SearchDonor, caseState: CaseSensitive) =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        dispatch(setSearchMessage(""));
        return request(
            `/MakeAWish/GetDonorsAsync`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    searchData: data,
                    caseSensitivity: caseState,
                    startsWith: true,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetDonor(data.donorsData));
                    if (data.additionalMessage != null) {
                        dispatch(setSearchMessage(data.additionalMessage));
                    }
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                dispatch(setSearchMessage(""));
                h.error("Error getting make a wish donor data.", error);
            });
    };

export const getEditDonorAsync =
    (id: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetEditDonorsAsync?id=${id}`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetEditDonor(data.donorsData));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish edit donor data.", error);
            });
    };

export const getEditDonorHistoryAsync =
    (id: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetEditDonorsHistoryAsync?id=${id}`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetEditDonorHistory(data.donorsHistoryData));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish edit donor data.", error);
            });
    };

export const getListAddressTypeAsync =
    () =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetListAddressTypeAsync`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetAddressType(data.addressTypeData));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish address type data.", error);
            });
    };

export const getListMemberCodeAsync =
    () =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetListMemberCodeAsync`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetMemberCode(data.memberCodeData));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish member code data.", error);
            });
    };

export const getListOriginCodeAsync =
    () =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetListOriginCodeAsync`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetOriginCode(data.originCodeData));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish origin code data.", error);
            });
    };

export const getListServiceCenterAsync =
    () =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetListServiceCenterAsync`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetServiceCenter(data.serviceCenterData));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish service center data.", error);
            });
    };

export const getListAcknowledgmentFlagAsync =
    () =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetListAcknowledgmentFlagAsync`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetAcknowledgmentFlag(data.flagsData));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish acknowledgment flags data.", error);
            });
    };

export const getListFormCodeAsync =
    () =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetListFormCodeAsync`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetFormCode(data.codesData));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish form codes data.", error);
            });
    };

export const getListAppealCodeAsync =
    (appealCode: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetListAppealCodeAsync?appealCode=${appealCode}`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetAppealCode(data.codesData));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish form codes data.", error);
            });
    };

export const getGiftSummaryAsync =
    (id: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetGiftSummaryAsync?id=${id}`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetGiftSummary(data.summary));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish gift summary.", error);
            });
    };

export const getAddressSummaryAsync =
    (id: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetAddressSummaryAsync?id=${id}`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetAddressSummary(data.summary));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish address summary.", error);
            });
    };

export const updateUserPermissions =
    (userPermissions: Array<UserPermission>) =>
    (dispatch: Dispatch): void => {
        request(
            `/MakeAWish/UpdateUserPermissionsAsync`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    userPermissions,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(getAllUserPermissions());
                    dispatch(notifyGreen("Permissions saved successfully."));
                }
            })
            .catch(error => {
                h.error("Error saving make a wish donor permissions.", error);
            });
    };

export const updateEditDonorsAsync =
    (data: Donor) =>
    (dispatch: Dispatch, getState: GetState): void => {
        dispatch(SetDonorIsLoading(true));
        const state: IAppState = getState();
        const user = state.session.userId ? state.session.userLogonId : "";
        data.LogonId = user;
        const donorId = data.Id || "";
        return request(
            `/MakeAWish/UpdateEditDonorsAsync`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    donorData: data,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(notifyGreen("Donor saved successfully."));
                    dispatch(getEditDonorAsync(donorId));
                    dispatch(SetDonorIsLoading(false));
                }
            })
            .catch(error => {
                h.error("Error saving make a wish donor data.", error);
                dispatch(SetDonorIsLoading(false));
            });
    };

export const getAuditRecsCountAsync =
    (batchNumber: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetAuditRecsCountAsync?batchNumber=${batchNumber}`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetAuditRecordsCount(data.recordsData));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish audit records count data.", error);
            });
    };

export const getAuditRecsAsync =
    (batchNumber: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetAuditRecsAsync?batchNumber=${batchNumber}`,
            {
                method: "POST",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetAuditRecords(data.recordsData));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish user batch data.", error);
            });
    };

export const getUserBatchesAsync =
    (logonId: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetUserBatchesAsync?logonId=${logonId}`,
            {
                method: "POST",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetUserBatches(data.batchesData));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish audit records data.", error);
            });
    };

export const getCurrentBatchAsync =
    (batchNumber: string, seqNumber?: string) =>
    (dispatch: Dispatch, getState: GetState): void => {
        dispatch(SetDonorIsLoading(true));
        const state: IAppState = getState();
        const user = state.session.userId ? state.session.userLogonId : "";
        const logonId = user;
        let params =
            seqNumber != null
                ? `batchNumber=${batchNumber}&seqNumber=${seqNumber}&logonId=${logonId}`
                : `batchNumber=${batchNumber}&logonId=${logonId}`;
        return request(
            `/MakeAWish/GetCurrentBatchAsync?` + params,
            {
                method: "POST",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetCurrentBatch(data.batchesData));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish current batch data.", error);
            });
    };

export const addAuditRecordAsync =
    (data: Batch) =>
    (dispatch: Dispatch, getState: GetState): void => {
        dispatch(SetDonorIsLoading(true));
        const state: IAppState = getState();
        const user = state.session.userId ? state.session.userLogonId : "";
        data.LogonId = user;
        return request(
            `/MakeAWish/AddAuditRecordAsync`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    batchData: data,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(AddAuditRecord(data.donorsData));
                    dispatch(notifyGreen("Added audit record successfully."));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error adding make a wish audit record data.", error);
            });
    };

export const updateAuditRecordAsync =
    (data: Batch) =>
    (dispatch: Dispatch, getState: GetState): void => {
        dispatch(SetDonorIsLoading(true));
        const state: IAppState = getState();
        const user = state.session.userId ? state.session.userLogonId : "";
        data.LogonId = user;
        return request(
            `/MakeAWish/UpdateAuditRecordAsync`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    batchData: data,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(UpdateAuditRecord(data.donorsData));
                    dispatch(notifyGreen("Updated audit record successfully."));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error updating make a wish audit record data.", error);
            });
    };

export const getAuditRecordAsync =
    (batchNumber: string, seqNumber: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetAuditRecordAsync?batchNumber=${batchNumber}&seqNumber=${seqNumber}`,
            {
                method: "POST",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetAuditRecord(data.recordData));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish user batch data.", error);
            });
    };

export const saveComment =
    (id: string, comment: string) =>
    (dispatch: Dispatch, getState: GetState): void => {
        const state: IAppState = getState();
        const user = state.session.userId ? state.session.userLogonId : "";
        return request(
            "/MakeAWish/SaveCommentAsync",
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    id,
                    comment,
                    user: user || "AE_USER",
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(UpdateComments(data.comments));
                    dispatch(notifyGreen("Comment saved."));
                }
            })
            .catch(error => {
                h.error("Error adding comment.", error);
            });
    };

export const getBatchDonorAsync =
    (id: string, recType: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetBatchDonorAsync?id=${id}&recType=${recType}`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetBatchDonor(data.donorsData));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish edit donor data.", error);
            });
    };

export const deleteBatchRecordAsync =
    (batchNumber: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/DeleteBatchRecordAsync?batchNumber=${batchNumber}`,
            {
                method: "DELETE",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(DeleteBatchRecord(true));
                    dispatch(notifyGreen("Batch record deleted successfully."));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                dispatch(DeleteBatchRecord(false));
                h.error("Error deleting make a wish batch record data.", error);
            });
    };

export const deleteAuditRecordAsync =
    (batchNumber: string, seqNumber: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/DeleteAuditRecordAsync?batchNumber=${batchNumber}&seqNumber=${seqNumber}`,
            {
                method: "DELETE",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(DeleteAuditRecord(true));
                    dispatch(notifyGreen("Audit record deleted successfully."));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                dispatch(DeleteAuditRecord(false));
                h.error("Error deleting make a wish audit record data.", error);
            });
    };

export const getPromotionInformation =
    (id: string, promoId: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetPromotionsLoading(true));
        return request(
            `/MakeAWish/GetPromotionInformationAsync?id=${id}&promoId=${promoId}`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetPromotionsLoading(false));
                if (data.success) {
                    dispatch(GetPromotionData(data.promotion));
                } else {
                    dispatch(GetPromotionData({}));
                    h.error("Error getting Used Make-a-Wish promotion information.");
                }
            })
            .catch(error => {
                dispatch(SetPromotionsLoading(false));
                dispatch(GetPromotionData({}));
                h.error("Error getting Used Make-a-Wish promotion information.", error);
            });
    };

export const getLinkedDonationInformation =
    (id: string, batchNumber: string, sequenceNumber: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonationsLoading(true));
        return request(
            `/MakeAWish/GetLinkedDonationInformationAsync?id=${id}&batchId=${batchNumber}&sequenceId=${sequenceNumber}`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonationsLoading(false));
                if (data.success) {
                    dispatch(GetLinkedDonationData(data.donation));
                } else {
                    dispatch(GetLinkedDonationData({}));
                    h.error("Error getting Used Make-a-Wish linked donation information.");
                }
            })
            .catch(error => {
                dispatch(SetDonationsLoading(false));
                dispatch(GetLinkedDonationData({}));
                h.error("Error getting Used Make-a-Wish linked donation information.", error);
            });
    };

export const getDonationInformation =
    (id: string, batchNumber: string, sequenceNumber: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonationsLoading(true));
        return request(
            `/MakeAWish/GetDonationInformationAsync?id=${id}&batchId=${batchNumber}&sequenceId=${sequenceNumber}`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonationsLoading(false));
                if (data.success) {
                    dispatch(GetDonationData(data.donation));
                } else {
                    dispatch(GetDonationData({}));
                    h.error("Error getting Used Make-a-Wish donation information.");
                }
            })
            .catch(error => {
                dispatch(SetDonationsLoading(false));
                dispatch(GetDonationData({}));
                h.error("Error getting Used Make-a-Wish donation information.", error);
            });
    };

export const deleteDonation =
    (id: string, batchNumber: string, sequenceNumber: string, logonId: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonationsLoading(true));
        return request(
            `/MakeAWish/DeleteDonationRecordAsync?identNumber=${id}&batchId=${batchNumber}&sequenceId=${sequenceNumber}&logonId=${logonId}`,
            {
                method: "DELETE",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonationsLoading(false));
                if (data.success) {
                    dispatch(getEditDonorHistoryAsync(id));
                } else {
                    // dispatch(getEditDonorHistoryAsync({}));
                    h.error("Error getting Make-a-Wish donation information.");
                }
            })
            .catch(error => {
                dispatch(SetDonationsLoading(false));
                dispatch(GetDonationData({}));
                h.error("Error getting Used Make-a-Wish donation information.", error);
            });
    };

export const getUsedInfoCodes =
    (id: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetCodesLoading(true));
        return request(
            `/MakeAWish/GetUsedInfoCodesAsync?id=${id}`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetCodesLoading(false));
                if (data.success) {
                    dispatch(GetUsedInfoCodes(data.codes));
                } else {
                    dispatch(GetUsedInfoCodes([]));
                    h.error("Error getting Used Make-a-Wish Info Codes.");
                }
            })
            .catch(error => {
                dispatch(SetCodesLoading(false));
                dispatch(GetUsedInfoCodes([]));
                h.error("Error getting Used Make-a-Wish Info Codes.", error);
            });
    };

export const getUnusedInfoCodes =
    (id: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetCodesLoading(true));
        return request(
            `/MakeAWish/GetUnusedInfoCodesAsync?id=${id}`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetCodesLoading(false));
                if (data.success) {
                    dispatch(GetUnusedInfoCodes(data.codes));
                } else {
                    dispatch(GetUnusedInfoCodes([]));
                    h.error("Error getting Unused Make-a-Wish Info Codes.");
                }
            })
            .catch(error => {
                dispatch(SetCodesLoading(false));
                dispatch(GetUnusedInfoCodes([]));
                h.error("Error getting Unused Make-a-Wish Info Codes.", error);
            });
    };

export const getUsedCampaignCodes =
    (id: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetCodesLoading(true));
        return request(
            `/MakeAWish/GetUsedCampaignCodesAsync?id=${id}`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetCodesLoading(false));
                if (data.success) {
                    dispatch(GetUsedCampaignCodes(data.codes));
                    dispatch(SetMailOnlySuppress(data.codes.length > 0 ? "M" : ""));
                } else {
                    dispatch(GetUsedCampaignCodes([]));
                    dispatch(SetMailOnlySuppress(""));
                    h.error("Error getting Used Make-a-Wish Campaign Codes.");
                }
            })
            .catch(error => {
                dispatch(SetCodesLoading(false));
                dispatch(GetUsedCampaignCodes([]));
                dispatch(SetMailOnlySuppress(""));
                h.error("Error getting Used Make-a-Wish Campaign Codes.", error);
            });
    };

export const getUnusedCampaignCodes =
    (id: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetCodesLoading(true));
        return request(
            `/MakeAWish/GetUnusedCampaignCodesAsync?id=${id}`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetCodesLoading(false));
                if (data.success) {
                    dispatch(GetUnusedCampaignCodes(data.codes));
                } else {
                    dispatch(GetUnusedCampaignCodes([]));
                    h.error("Error getting Unused Make-a-Wish Campaign Codes.");
                }
            })
            .catch(error => {
                dispatch(SetCodesLoading(false));
                dispatch(GetUnusedCampaignCodes([]));
                h.error("Error getting Unused Make-a-Wish Campaign Codes.", error);
            });
    };

export const getUsedFinanceCodes =
    (id: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetCodesLoading(true));
        return request(
            `/MakeAWish/GetUsedFinanceCodesAsync?id=${id}`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetCodesLoading(false));
                if (data.success) {
                    dispatch(GetUsedFinanceCodes(data.codes));
                } else {
                    dispatch(GetUsedFinanceCodes([]));
                    h.error("Error getting Used Make-a-Wish Finance Codes.");
                }
            })
            .catch(error => {
                dispatch(SetCodesLoading(false));
                dispatch(GetUsedFinanceCodes([]));
                h.error("Error getting Used Make-a-Wish Finance Codes.", error);
            });
    };

export const getUnusedFinanceCodes =
    (id: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetCodesLoading(true));
        return request(
            `/MakeAWish/GetUnusedFinanceCodesAsync?id=${id}`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetCodesLoading(false));
                if (data.success) {
                    dispatch(GetUnusedFinanceCodes(data.codes));
                } else {
                    dispatch(GetUnusedFinanceCodes([]));
                    h.error("Error getting Unused Make-a-Wish Finance Codes.");
                }
            })
            .catch(error => {
                dispatch(SetCodesLoading(false));
                dispatch(GetUnusedFinanceCodes([]));
                h.error("Error getting Unused Make-a-Wish Finance Codes.", error);
            });
    };

export const saveInfoCodesAsync =
    (id: string, codes: Array<string>) =>
    (dispatch: Dispatch, getState: GetState): void => {
        const state: IAppState = getState();
        const userId = state.session.userId ? state.session.userLogonId : "";

        return request(
            `/MakeAWish/SaveInfoCodesAsync?id=${id}&userId=${userId}`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    codes,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(notifyGreen("Info Codes saved successfully."));
                } else {
                    h.error("Error saving info codes.");
                }
            })
            .catch(error => {
                h.error("Error saving info codes.", error);
            });}

export const saveCampaignCodesAsync =
    (id: string, codes: Array<string>) =>
    (dispatch: Dispatch, getState: GetState): void => {
        const state: IAppState = getState();
        const userId = state.session.userId ? state.session.userLogonId : "";

        return request(
            `/MakeAWish/SaveCampaignCodesAsync?id=${id}&userId=${userId}`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    codes,
                    mailOnlySuppress: codes.length > 0,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(notifyGreen("Campaign Codes saved successfully."));
                } else {
                    h.error("Error saving campaign codes.");
                }
            })
            .catch(error => {
                h.error("Error saving campaign codes.", error);
            });
        }

export const saveFinanceCodesAsync =
    (id: string, codes: Array<string>) =>
    (dispatch: Dispatch): void =>
        request(
            `/MakeAWish/SaveFinanceCodesAsync?id=${id}`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    codes,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(notifyGreen("Finance Codes saved successfully."));
                } else {
                    h.error("Error saving finance codes.");
                }
            })
            .catch(error => {
                h.error("Error saving finance codes.", error);
            });

export const getOtherAddresses =
    (id: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetOtherAddressesAsync?id=${id}`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetOtherAddresses(data.addresses));
                } else {
                    dispatch(GetOtherAddresses([]));
                    h.error("Error getting other addresses.");
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                dispatch(GetOtherAddresses([]));
                h.error("Error getting other addresses.", error);
            });
    };

export const updateDonationData =
    (id: string, donation: DonationData) =>
    (dispatch: Dispatch, getState: GetState): void => {
        const state: IAppState = getState();
        const user = state.session.userId ? state.session.userLogonId : "";
        donation.LOGON_ID = user;
        return request(
            `/MakeAWish/UpdateDonationData`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    id,
                    donation,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(notifyGreen("Donation updated successfully."));
                    dispatch(getEditDonorHistoryAsync(id));
                } else {
                    h.error("Error updating donation.");
                }
            })
            .catch(error => {
                h.error("Error updating donation.", error);
            });
    };

export const updateOtherAddress =
    (id: string, address: Address) =>
    (dispatch: Dispatch): void =>
        request(
            `/MakeAWish/UpdateOtherAddress`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    address,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(notifyGreen("Address updated successfully."));
                } else {
                    h.error("Error updating address.");
                }
                dispatch(getOtherAddresses(id));
            })
            .catch(error => {
                h.error("Error updating address.", error);
            });

export const deleteOtherAddress =
    (id: string, address: Address) =>
    (dispatch: Dispatch): void =>
        request(
            `/MakeAWish/DeleteOtherAddress`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    address,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(notifyGreen("Address removed successfully."));
                } else {
                    h.error("Error removing address.");
                }
                dispatch(getOtherAddresses(id));
            })
            .catch(error => {
                h.error("Error removing address.", error);
            });

export const addOtherAddress =
    (id: string, address: Address) =>
    (dispatch: Dispatch): void =>
        request(
            `/MakeAWish/AddOtherAddress`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    address,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(notifyGreen("Address added successfully."));
                } else {
                    h.error("Error adding address.");
                }
                dispatch(getOtherAddresses(id));
            })
            .catch(error => {
                h.error("Error adding address.", error);
            });

export const addBatchHeaderAsync =
    (data: Batch) =>
    (dispatch: Dispatch, getState: GetState): void => {
        dispatch(SetDonorIsLoading(true));
        const state: IAppState = getState();
        const user = state.session.userId ? state.session.userLogonId : "";
        data.LogonId = user;
        return request(
            `/MakeAWish/AddBatchHeaderAsync`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    batchData: data,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(AddHeaderRecord(data.batchData));
                    dispatch(notifyGreen("Added header record successfully."));
                    dispatch(goToUrl(`/make-a-wish/edit-batch/${data.batchData}`));
                } else {
                    h.error("Error adding make a wish header record data.", data.messages);
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error adding make a wish header record data.", error);
            });
    };

export const updateBatchHeaderAsync =
    (batchData: Batch) =>
    (dispatch: Dispatch): void =>
        request(
            `/MakeAWish/UpdateBatchHeaderAsync`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    batchData,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(UpdateHeaderRecord());
                    dispatch(getCurrentBatchAsync(batchData.BatchNumber || ""));
                    dispatch(notifyGreen("Batch header updated successfully."));
                }
            })
            .catch(error => {
                h.error("Error updating make a wish batch data.", error);
            });

export const saveDonorAsync =
    (data: Donor) =>
    (dispatch: Dispatch, getState: GetState): void => {
        const state: IAppState = getState();
        const user = state.session.userId ? state.session.userLogonId : "";
        data.LogonId = user;
        return request(
            `/MakeAWish/SaveDonorAsync`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    donor: data,
                    user,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    let id = data.id;
                    dispatch(notifyGreen("Donor saved successfully."));
                    dispatch(goToUrl(`/make-a-wish/edit/${id}`));
                }
            })
            .catch(error => {
                h.error("Error saving make a wish donor data.", error);
            });
    };

export const getReports =
    () =>
    (dispatch: Dispatch): void => {
        dispatch(SetIsReportsLoading(true));
        return request(
            `/MakeAWish/GetReports`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetIsReportsLoading(false));
                if (data.success) {
                    dispatch(SetReports(data.reports));
                } else {
                    dispatch(SetReports([]));
                    h.error("Error getting Make-A-Wish reports.");
                }
            })
            .catch(error => {
                dispatch(SetIsReportsLoading(false));
                dispatch(SetReports([]));
                h.error("Error getting Make-A-Wish reports.", error);
            });
    };

export const getUserPermission =
    (logonId: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetIsReportsLoading(true));
        return request(
            `/MakeAWish/GetUserPermissionAsync?logonId=` + logonId,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    logonId,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(SetUserPermission(data.userPermission));
                } else {
                    dispatch(SetUserPermission({}));
                    h.error("Error getting Make-A-Wish permissions.");
                }
            })
            .catch(error => {
                dispatch(SetUserPermission({}));
                dispatch(SetReports([]));
                h.error("Error getting Make-A-Wish permissions.", error);
            });
    };

export const getAllUserPermissions =
    () =>
    (dispatch: Dispatch): void =>
        request(
            `/MakeAWish/GetAllUserPermissionsAsync`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(SetAllUserPermissions(data.userPermissions));
                } else {
                    dispatch(SetAllUserPermissions([]));
                    h.error("Error getting Make-A-Wish permissions.");
                }
            })
            .catch(error => {
                dispatch(SetAllUserPermissions([]));
                h.error("Error getting Make-A-Wish permissions.", error);
            });

export const getAllGiftsSchedule =
    () =>
    (dispatch: Dispatch): void => {
        dispatch(SetIsAllGiftsLoading(true));
        return request(
            `/MakeAWish/GetAllGiftsSchedule`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetIsAllGiftsLoading(false));
                if (data.success) {
                    dispatch(SetAllGifts(data.allGiftsSchedule));
                } else {
                    dispatch(SetAllGifts([]));
                    h.error("Error getting Make-A-Wish all gifts schedule.");
                }
            })
            .catch(error => {
                dispatch(SetIsAllGiftsLoading(false));
                dispatch(SetAllGifts([]));
                h.error("Error getting Make-A-Wish all gifts schedule.", error);
            });
    };

export const editAllDates =
    (runDate: string, startDate: string, endDate: string) =>
    (dispatch: Dispatch): void => {
        request(
            `/MakeAWish/UpdateAllDates`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    runDate,
                    startDate,
                    endDate,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(getAllGiftsSchedule());
                    dispatch(notifyGreen("Dates updated successfully."));
                } else {
                    h.error("Error updating dates in the schedule.");
                }
            })
            .catch(error => {
                h.error("Error updating dates in the schedule.", error);
                dispatch(SetDonorIsLoading(false));
            });
    };

export const submitBatchAsync =
    (batchNumber: string, seqNumber: string, actualCount: string, actualAmount: string) =>
    (dispatch: Dispatch): void => {
        request(
            `/MakeAWish/SubmitBatchAsync?batch_Number=${batchNumber}&seq_Number=${seqNumber}&actual_Count=${actualCount}&actual_Amount=${actualAmount}`,
            {
                method: "POST",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(notifyGreen("Batch submitted successfully."));
                } else {
                    h.error("Error submitting batch.");
                }
            })
            .catch(error => {
                h.error("Error submitting batch.", error);
            });
    };

export const addGift =
    (gift: IGift) =>
    (dispatch: Dispatch): void => {
        request(
            `/MakeAWish/AddGift`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    gift,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(getAllGiftsSchedule());
                    dispatch(notifyGreen("Gift saved successfully."));
                } else {
                    h.error("Error saving gift in the schedule.");
                }
            })
            .catch(error => {
                h.error("Error saving gift in the schedule.", error);
                dispatch(SetDonorIsLoading(false));
            });
    };
export const editGift =
    (gift: IGift) =>
    (dispatch: Dispatch): void => {
        request(
            `/MakeAWish/EditGift`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    gift,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(getAllGiftsSchedule());
                    dispatch(notifyGreen("Gift updated successfully."));
                } else {
                    h.error("Error updating gift in the schedule.");
                }
            })
            .catch(error => {
                h.error("Error updating gift in the schedule.", error);
                dispatch(SetDonorIsLoading(false));
            });
    };
export const deleteGift =
    (gift: IGift) =>
    (dispatch: Dispatch): void => {
        request(
            `/MakeAWish/DeleteGift`,
            {
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify({
                    gift,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(getAllGiftsSchedule());
                    dispatch(notifyGreen("Gift deleted successfully."));
                } else {
                    h.error("Error deleting gift in the schedule.");
                }
            })
            .catch(error => {
                h.error("Error deleting gift in the schedule.", error);
                dispatch(SetDonorIsLoading(false));
            });
    };

export const updatePrimaryIdentBatchAsync =
    (batchNumber: string, seqNumber: string, assocident: string) =>
    (dispatch: Dispatch): void => {
        request(
            `/MakeAWish/UpdatePrimaryIdentBatchAsync?batch_Number=${batchNumber}&seq_Number=${seqNumber}&assocident=${assocident}`,
            {
                method: "POST",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(UpdatedAuditableBatch());
                    dispatch(notifyGreen("Auditable batch updated successfully."));
                }
            })
            .catch(error => {
                h.error("Error updating make a wish auditable batch data.", error);
                dispatch(SetDonorIsLoading(false));
            });
    };

export const updateAssocIdentBatchAsync =
    (batchNumber: string, seqNumber: string, assocident: string, tribtype: string) =>
    (dispatch: Dispatch): void => {
        request(
            `/MakeAWish/UpdateAssocIdentBatchAsync?batch_Number=${batchNumber}&seq_Number=${seqNumber}&assocident=${assocident}&tribtype=${tribtype}`,
            {
                method: "POST",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(UpdatedAuditableBatch());
                    dispatch(notifyGreen("Auditable batch updated successfully."));
                }
            })
            .catch(error => {
                h.error("Error updating make a wish auditable batch data.", error);
                dispatch(SetDonorIsLoading(false));
            });
    };

export const updateNotifyIdentBatchAsync =
    (batchNumber: string, seqNumber: string, notifyident: string) =>
    (dispatch: Dispatch): void => {
        request(
            `/MakeAWish/UpdateNotifyIdentBatchAsync?batch_Number=${batchNumber}&seq_Number=${seqNumber}&notifyident=${notifyident}`,
            {
                method: "POST",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(UpdatedAuditableBatch());
                    dispatch(notifyGreen("Auditable batch updated successfully."));
                }
            })
            .catch(error => {
                h.error("Error updating make a wish auditable batch data.", error);
                dispatch(SetDonorIsLoading(false));
            });
    };

export const updateLinkedIdentBatchAsync =
    (batchNumber: string, seqNumber: string, linkedident: string) =>
    (dispatch: Dispatch): void => {
        request(
            `/MakeAWish/UpdateLinkedIdentBatchAsync?batch_Number=${batchNumber}&seq_Number=${seqNumber}&linkedident=${linkedident}`,
            {
                method: "POST",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(UpdatedAuditableBatch());
                    dispatch(notifyGreen("Auditable batch updated successfully."));
                }
            })
            .catch(error => {
                h.error("Error updating make a wish auditable batch data.", error);
                dispatch(SetDonorIsLoading(false));
            });
    };

export const getLisTributeTypeAsync =
    () =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetLisTributeTypeAsync`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetTributeType(data.tributeTypeData));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish tribute type data.", error);
            });
    };

export const getListGiftTypeAsync =
    () =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetListGiftTypeAsync`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetGiftType(data.giftTypeData));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish gift type data.", error);
            });
    };

export const zipLookup =
    (zipCode: string) =>
    (dispatch: Dispatch): void =>
        request(
            `/MakeAWish/ZipLookup?zipCode=${zipCode}`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                const response = data as unknown as {
                    success: boolean;
                    serviceCenterZip?: ServiceCenterZip;
                    message: string;
                };
                if (response.success) {
                    dispatch(SetServiceCenterZip(response.serviceCenterZip));
                } else {
                    notifyBlue("Unable to find information for this zip code.");
                }
            })
            .catch(error => {
                h.error("Error looking up zip code information.", error);
            });

export const getListBatchCategoryAsync =
    () =>
    (dispatch: Dispatch): void => {
        dispatch(SetDonorIsLoading(true));
        return request(
            `/MakeAWish/GetListBatchCategoryAsync`,
            {
                method: "GET",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDonorIsLoading(false));
                if (data.success) {
                    dispatch(GetBatchCategories(data.batchCategoryData));
                }
            })
            .catch(error => {
                dispatch(SetDonorIsLoading(false));
                h.error("Error getting make a wish batch category data.", error);
            });
    };
